import { defer, LoaderFunctionArgs } from 'react-router-dom';
import { IFetchTickersPayload, ITicker } from '@kattana-io/common';
import { KattanaAPI } from '../../store/createStore';

export type newPairsPageLoaderPDataType = ITicker[] | null;

const newPairsLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const page = url.searchParams.get('page') || 1;
  const chain = url.searchParams.get('chain') || '';

  let args: IFetchTickersPayload = {
    chain,
    sort: { name: 'pool_created', order: 'DESC' },
  };
  if (page > 1) {
    args = {
      ...args,
      page: Number(page) - 1,
    };
  }
  const tickers = KattanaAPI.tickers(args, {
    signal: request.signal,
  });

  return defer({ tickers });
};

export default newPairsLoader;
